import type { RequestConfig } from '@customTypes/index';
import type { ArtistLanguageDto } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type ArtistPostProfileLanguagesRequest = {
  profileId: string;
  data: ArtistLanguageDto[];
};

export type ArtistPostProfileLanguagesParams =
  RequestConfig<ArtistPostProfileLanguagesRequest>;

export const artistPostProfileLanguages = async ({
  params,
  config
}: ArtistPostProfileLanguagesParams) =>
  api.post(
    `/api/ArtistProfile/${params.profileId}/languages`,
    params.data,
    config
  );
